<template>
  <section class="locate_view">
    <!--    地图start-->
    <section>
      <div style="width: 100%;height: 800px">
        <baidu-map class="map" :center="{lng: 116.404, lat: 39.915}"  @ready="handler" :scroll-wheel-zoom="true" :zoom="5">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <bml-marker-clusterer :averageCenter="true" v-if="markers.length!==0">
            <bm-marker v-for="marker of markers" :position="{lng: marker.lng, lat: marker.lat}" @click="showPoint(marker,'show')" >
              <bm-label :content="marker.plateNumber" :labelStyle="{color: '#0088FF', fontSize : '12px', borderColor:'#0088FF'}" :offset="{width: 15, height: -20}"/>
            </bm-marker>
          </bml-marker-clusterer>
        </baidu-map>
      </div>
    </section>
    <!--    地图end-->

    <!--    车辆列表start-->
    <section class="organization">
        <section class="posiab orgBox">
          <qx-card title="车辆列表" v-show="showCarList" style="position:relative;overflow-y: scroll">
            <span slot="titleRight">{{vehicleCount}}辆</span>
            <el-input
                placeholder="请输入车牌号"
                v-model="filterText">
<!--              <el-button slot="suffix" type="primary" @click="() => filterNode(filterText,...treeData)">-->
<!--                <i class="el-icon-search" />-->
<!--                搜索-->
<!--              </el-button>-->
            </el-input>
            <el-tree
                :data="treeData"
                :show-checkbox="true"
                node-key="orgId"
                ref="tree"
                :props="defaultProps"
                :default-expanded-keys="[1]"
                :expand-on-click-node="true"
                :default-expand-all="true"
                @node-click="handleNodeClick"
                highlight-current
                :filter-node-method="filterNode"
                @check-change="handleCheckChange"
            >
              <section class="clearPa treeNodeBox" slot-scope="{ node, data }" >
                <section class="left" :title="data.vechileNum ? node.label  + '（' +data.vechileNum+'）' :node.label">{{ node.label }}
                  <span v-if="data.vechileNum">（{{data.vechileNum}}）</span>
                </section>
              </section>
            </el-tree>
          </qx-card>
          <div :class="showCarList?'zdright':'zdleft'" @click="toShowCarList()"></div>
        </section>
      </section>
    <!--    车辆列表end-->

    <!--    车辆状态表格start-->
    <section class="carStatusBox">
      <TableBox ref="tableBox" @locate="showPoint"/>
    </section>
    <!--    车辆状态表格end-->

    <CarDetailDialog ref="carDetailDialog" />

  </section>


</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import {BmlMarkerClusterer} from 'vue-baidu-map';
import BmMarker from 'vue-baidu-map/components/overlays/Marker';
import {loadOrgVehicleTree, queryVehicleMonitorTrackInfo } from 'api/index';
import TableBox from './tableBox';
import CarDetailDialog from './carDetailDialog';
import {mapMutations, mapState} from 'vuex';
export default {
  components: {
    BaiduMap,
    BmlMarkerClusterer,
    BmMarker,
    TableBox,
    CarDetailDialog,
  },
  data () {
    return {
      markers: [],
      center: {lng: 116.404, lat: 39.915},
      map: {},
      showCarList: true, // 车辆列表“展开”“缩放”按钮
      position: [],
      plateNumber: '',
      vehicleCount: 0,
      treeData: [],
      defaultProps: {
        children: 'childOragnizes',
        label: 'orgName',
      },
      filterText: '',
    };
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
    ...mapState({
      locateCarList: (state) => state.locate.locateCarList,
    }),
  },
  methods: {
    ...mapMutations({
      saveLocateCarList: 'locate/saveLocateCarList', // 保存聚合车辆数据
    }),
    handleNodeClick (data, item) {
      if (data.plateNumber && data.orgName === data.plateNumber) {
        const res = this.locateCarList.filter((item) => item.plateNumber === data.plateNumber);
        // 定位到该车的位置并打开车辆详情弹框
        this.showPoint(res[0]);
      }
    },
    handleCheckChange () {
      const filterData = this.locateCarList.filter((item) => this.$refs.tree.getCheckedKeys().includes(item.plateNumber));
      this.setFocusCar(filterData);
    },
    filterNode (value, data) { // 筛选车牌号
      if (!value) {return true;}
      return data.orgName.indexOf(value) !== -1;
    },
    toShowCarList () {
      this.showCarList = !this.showCarList;
    },
    async getData () {
      const res = await loadOrgVehicleTree({
        plateNumber: this.plateNumber,
      });
      if (!res.failed) {
        this.treeData = res.childOragnizes;
        this.vehicleCount = res.vechileNum;
        this.$refs.tableBox.saveSearchBoxData({
          vehicleStateJt808: 0,
        });
        this.$refs.tree.setCheckedKeys(res.orgIdData);
      }
    },
    async getCarData () {
      const position = await queryVehicleMonitorTrackInfo();
      if (!position.failed) {
        this.saveLocateCarList(position);
        this.setFocusCar(position);
      }
    },
    setFocusCar (position) {
      this.markers = [];
      this.markers.push(...position);
    },
    async handler ({BMap, map}) {
      this.map = map;
    },
    showPoint (item, show) {
      // show用来判断点车牌时，地图不再进行缩放
      if (item.lng && item.lat && !show) {
        this.map.centerAndZoom(new BMap.Point(item.lng, item.lat), 12);
      }
      this.$refs.carDetailDialog.show(item);


    },
  },
  async mounted () {
    await this.getData();
    await this.getCarData();
  },
};
</script>

<style scoped lang="scss">
.locate_view{
  position: relative;

  //地图
  .map{
    width: 100%;
    height: 100%;
  }

  //车辆列表
  .organization {
    position: absolute;
    right: -12px;
    top: -7px;
    padding-left: 258px;
    height: calc(100% - 50px);

    .orgBox {
      width: 250px;
      height: 100%;
      top: 0;
      left: 0;
      height: 100%;

      ::v-deep .card{
        height: 100%
      }

      .iconfont{
        font-size:26px
      }

      .treeNodeBox {
        width: 100%;
      }
    }

    ::v-deep .el-tree-node__content {
      .btnBox {
        display: none;
      }
    }

    ::v-deep .el-tree-node__content:hover {
      .btnBox {
        display: block;
      }
    }
  }

  //车辆状态表格
  .carStatusBox{
    z-index: 1;
    position: absolute;
    bottom: -25px;
    width: 100%;
  }

  .zdright{
    width:30px;
    height: 50px;
    background-image: url('~images/monitoreScreen/list_show.png');
    position: absolute;
    top:calc(50% - 25px);
    left: -28px;
  }
  .zdleft{
    width:30px;
    height: 50px;
    background-image: url('~images/monitoreScreen/list_hide.png');
    position: absolute;
    top:calc(50% - 25px);
    right: 0;
  }
}


</style>
